import { render, staticRenderFns } from "./OTPLogin.vue?vue&type=template&id=005f642e&scoped=true&"
import script from "./OTPLogin.vue?vue&type=script&lang=js&"
export * from "./OTPLogin.vue?vue&type=script&lang=js&"
import style0 from "./OTPLogin.vue?vue&type=style&index=0&id=005f642e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f642e",
  null
  
)

export default component.exports